<main id="technical-charging-stations" class="technical-charging-stations">
  <div class="container-fluid">
    <div class="card">
      <div class="card-header">
        <h5 class="mb-0" i18n="@@TechnicalChargingStationsTitle">Ladestationen</h5>
      </div>
      <div class="card-body">
        <p class="text-muted mb-4" i18n="@@TechnicalChargingStationsIntro">Übersicht aller Ladestationen mit Status, Konnektoren und Aktionen (Neustart, Sperren/Entsperren, Roaming, Konnektor entriegeln).</p>

        <div class="clearfix mb-3">
          <form class="float-start">
            <div i18n="@@Search" style="min-width:200px;">
              <input class="form-control" id="table_search" type="text" name="searchTerm"
                [(ngModel)]="tableFunctions.searchTerm" i18n-placeholder="@@SearchAll" placeholder="Alles durchsuchen..." />
            </div>
          </form>
        </div>

        <div *ngIf="tableReady" [class]="tableView">
          <app-table [id]="className + 'Table'" [table]="table" (sorted)="onSort()" [class]="tableFunctions.getTableLayout(className)"></app-table>
        </div>

        <div *ngIf="!tableReady" class="loading-spinner-container">
          <div class="spinner-border text-primary loading-spinner-md" role="status">
            <span class="visually-hidden-focusable" i18n="@@LoadingMessage">Loading...</span>
          </div>
        </div>
      </div>
      <div class="card-footer" [ngStyle]="{'display': componentSettings.footerVisible == true ? 'block' : 'none' }">
        <div class="d-flex">
          <div class="flex-fill d-none d-md-inline">
            <div class="d-flex">
              <div class="flex p-2" i18n="@@ElementsPerPage">Elemente pro Seite</div>
              <div class="flex">
                <select id="pageSize" name="pageSize" [(ngModel)]="tableFunctions.pageSize"
                        class="form-control form-select custom-select" aria-label=""
                        (change)="tableFunctions.onPageSizeChange(className)">
                  <option [ngValue]="10">10</option>
                  <option [ngValue]="25">25</option>
                  <option [ngValue]="50">50</option>
                  <option [ngValue]="100">100</option>
                  <option [ngValue]="250">250</option>
                </select>
              </div>
            </div>
          </div>
          <div class="d-flex d-md-inline-flex flex-fill text-center justify-content-center">
            <ngb-pagination #pagination [collectionSize]="(tableFunctions.total$ | async)!"
                            [(page)]="tableFunctions.page" [pageSize]="tableFunctions.pageSize"
                            [maxSize]="tableFunctions.page == 3 ? 3 : 2" [boundaryLinks]="true" [rotate]="true">
            </ngb-pagination>
          </div>
          <div class="flex-fill justify-content-end d-none d-md-inline">
            <div class="d-flex float-end">
              <div class="flex p-2" i18n="@@GoToPage">Springe zu Seite</div>
              <div class="flex">
                <select id="page" name="page" [(ngModel)]="tableFunctions.page" class="form-control form-select"
                        aria-label="">
                  <option *ngFor="let page of [].constructor(pagination.pageCount); let i = index"
                          [ngValue]="i + 1">
                    {{ i + 1 }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<ng-template let-entity="entity" #actionsTemplate>
  <div class="d-flex flex-nowrap gap-2 justify-content-end">
    <button type="button" class="btn btn-yellow btn-sm" id="actions-{{ entity.id }}"
      ngbTooltip="Aktionen" i18n-ngbTooltip="@@TechnicalChargingStationsActions"
      (click)="openActionsModal(entity)">
      <app-svg source="icons/feather/settings" height="18"></app-svg>
    </button>
    <button type="button" class="btn btn-outline-secondary btn-sm" id="unlock-{{ entity.id }}"
      *ngIf="connectorCount(entity) > 0"
      ngbTooltip="Konnektor entriegeln" i18n-ngbTooltip="@@TechnicalChargingStationsUnlockConnectorTooltip"
      (click)="openUnlockModal(entity)">
      <app-svg source="icons/feather/unlock" height="18"></app-svg>
    </button>
  </div>
</ng-template>
